import React, {useState, useEffect, useCallback} from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useUserSession } from '../contexts/UserContext.js';
import { usePendingOperations } from '../contexts/PendingOperationsContext.js';
import { isDevelopment } from '../utils/environment.js';
import './topMenu.css';
import profileImage from '../Ui/profilePic.webp';
import profile from '../Ui/profile1.webp';
import settings from '../Ui/setting.webp';
import feedback from '../Ui/feedback.webp'
import share from '../Ui/share.webp';
import hub from '../Ui/hub.webp';
import brain from '../Ui/brain.webp';
import logo from '../Ui/LogoNewColorTrimmedGrey.webp';


const TopMenu = ({ handleViewChange, isLandingPage = false }) => {
  const { isAuthenticated, user, loginWithRedirect, logout } = useAuth0();
  const { hasElevatedAccess, isGodUser, userSession, clearSession } = useUserSession();
  const { requestNavigation } = usePendingOperations();
  const [useMockAuth, setUseMockAuth] = useState(false);

  // Wrap view changes with navigation guard - blocks if save in progress
  const safeViewChange = useCallback((view) => {
    requestNavigation(() => handleViewChange(view));
  }, [handleViewChange, requestNavigation]);

  // Check if we're on localhost for dev mode - SECURE IMPLEMENTATION
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const allowDevBypass = isLocalhost && isDevelopment();

  useEffect(() => {
    // Automatically determine the authentication method based on the hostname
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname.startsWith('127.') || hostname.startsWith('192.168')) {
      setUseMockAuth(true);
    } else {
      setUseMockAuth(false);
    }
  }, []);

  const handleLogout = () => {
    if (isAuthenticated && !useMockAuth) {
      // CRITICAL: Clear all session data BEFORE Auth0 logout
      clearSession();
      logout({ returnTo: window.location.origin });
    }
  };

  const handleNotyet = () => {
    alert("You have not been validated yet, we will be sure to email you once you're in");
  }
  
  const handleSignIn = async () => {
    if (useMockAuth) {
      // Mock auth for local development
    } else {
      try {
        await loginWithRedirect();
      } catch (error) {
        // Sign-in failed
      }
    }
  };

  const handleShare = () => {
    let shareUrl = 'https://intellegacy.app';
    let shareText = 'Join Intellegacy - Upload yourself to the cloud, and create an AI you - the first step to immortality!';
    
    // If user is authenticated and has a referral code, use personal link
    if (isAuthenticated && userSession?.user?.referralCode) {
      shareUrl = `https://intellegacy.app/register?ref=${userSession.user.referralCode}`;
      shareText = 'Join me on Intellegacy! Upload yourself to the cloud, and create an AI you - the first step to immortality!';
    }

    if (navigator.share && shareUrl) {
      navigator.share({
        title: 'Join Intellegacy',
        text: shareText,
        url: shareUrl
      }).catch(() => {});
    } else if (shareUrl) {
      // Fallback for browsers that don't support Web Share API
      navigator.clipboard.writeText(`${shareText} ${shareUrl}`);
      alert('Share text copied to clipboard');
    }
  };

  if (isLandingPage) {
    return (
  <div className='MenuContainerDark'>
    {((allowDevBypass && userSession.isLoaded && hasElevatedAccess()) || (isAuthenticated || user)) ? (
          <>
          <div className='LeftBlock'><img className='logo' src={ logo } alt='logo'/></div>
              <button className='topmenuButtonDark' onClick={() => safeViewChange('')} aria-label="Main hub">
          <img className='topmenuIconDark' src={ hub } alt="main hub"></img>
          </button>
          {isGodUser() && (
            <button className='topmenuButtonDark' onClick={() => safeViewChange('god')} title="God Management" aria-label="God Dashboard">
                <img className='topmenuIconDark' src={ brain } alt="God Dashboard"></img>
            </button>
          )}
          <button className='topmenuButtonDark' onClick={() => safeViewChange('settings')} aria-label="Settings">
          <img className='topmenuIconDark' src={ settings } alt="settings" title="Settings"></img>
          </button>
          <button className='topmenuButtonDark' onClick={() => safeViewChange('feedback')} aria-label="Feedback">
          <img className='topmenuIconDark' src={ feedback } alt="feedback" title="Feedback"></img>
          </button>
          <button className='topmenuButtonDark' onClick={() => safeViewChange('profile')} aria-label="Profile">
          <img className='topmenuIconDark' src={ profile } alt="profile" title="Profile"></img>
          </button>
          <button className='topmenuButtonDark' onClick={ handleShare } aria-label="Share">
          <img className='topmenuIconDark' src={ share } alt="share" title="Share"></img>
          </button>
          <button className='ButtonDark' onClick={handleLogout}>
            <label className='ButtonDarkText'>Log Out</label>
          </button>
          </>
    ):(
          <>
          <div className='LeftBlock'><img className='logo' src={ logo } alt='logo'/></div>
            <button className='topmenuButtonDark' onClick={() => safeViewChange('')} aria-label="Main hub">
          <img className='topmenuIconDark' src={ hub } alt="main hub"></img>
          </button>
          <button className='topmenuButtonDark' onClick={() => safeViewChange('settings')} aria-label="Settings">
          <img className='topmenuIconDark' src={ settings } alt="settings"></img>
          </button>
          <button className='topmenuButtonDark' onClick={() => safeViewChange('feedback')} aria-label="Feedback">
          <img className='topmenuIconDark' src={ feedback } alt="feedback"></img>
          </button>
          <button className='topmenuButtonDark' onClick={() => safeViewChange('profile')} aria-label="Profile">
          <img className='topmenuIconDark' src={ profile } alt="profile"></img>
          </button>
          <button className='topmenuButtonDark' onClick={ handleShare } aria-label="Share">
          <img className='topmenuIconDark' src={ share } alt="share"></img>
          </button>
          <button className='ButtonDark' onClick={handleSignIn}>
            <label className='ButtonDarkText'>Sign In</label>
          </button>
          </>
    )}
      </div>
    );
  }
  
    return (
<div className='MenuContainer'>
  {((allowDevBypass && userSession.isLoaded && hasElevatedAccess()) || (isAuthenticated || user)) ? (
        
        <>
        <div className='LeftBlock'><img className='logo' src={ logo } alt='logo'/></div>
        <button className='topmenuButton' onClick={() => safeViewChange('dashboard')} aria-label="Main hub">
          <img className='topmenuIcon' src={ hub } alt="main hub"></img>
        </button>
        {isGodUser() && (
          <button className='topmenuButton' onClick={() => safeViewChange('god')} title="God Management" aria-label="God Dashboard">
                <img className='topmenuIcon' src={ brain } alt="God Dashboard"></img>
          </button>
        )}
        <button className='topmenuButton' onClick={() => safeViewChange('settings')} aria-label="Settings">
        <img className='topmenuIcon' src={ settings } alt="settings" title="Settings"></img>
        </button>
        <button className='topmenuButton' onClick={() => safeViewChange('feedback')} aria-label="Feedback">
        <img className='topmenuIcon' src={ feedback } alt="feedback" title="Feedback"></img>
        </button>
        <button className='topmenuButton' onClick={() => safeViewChange('profile')} aria-label="Profile">
        <img className='topmenuIcon' src={ profile } alt="profile" title="Profile"></img>
        </button>
        <button className='topmenuButton' onClick={ handleShare } aria-label="Share">
        <img className='topmenuIcon' src={ share } alt="share" title="Share"></img>
        </button>
        <button className='signUpButton' onClick={ handleLogout }>
          Log Out
        </button>
        </>
      ) : (
        <>
        <div className='LeftBlock'><img className='logo' src={ logo } alt='logo'/></div>
        <button className='signUpButton' onClick={handleSignIn}>
          Sign In
        </button>
        </>
      )}
    </div>
  );
};

export default TopMenu; 